import { useState, type FormEvent } from "react";

const FORM_URL = "https://readdy.ai/api/form/daetrhjep053ijub1hhg";

export default function Subscribe() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);

    const honeypot = String(data.get("website_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功！吃瓜晚报会第一时间送到你邮箱。");
      form.reset();
      return;
    }
    data.delete("website_alt");

    try {
      const response = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam =
        responseText.toLowerCase().includes("spam") || serverMsg.toLowerCase().includes("spam");

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setMessage("订阅成功！吃瓜晚报会第一时间送到你邮箱。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "订阅失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络开小差了，请稍后再试。");
    }
  };

  return (
    <section
      id="subscribe"
      className="relative overflow-hidden bg-background-900 py-16 md:py-20"
    >
      <img
        src="https://readdy.ai/api/search-image?query=wide%20warm%20editorial%20banner%20of%20a%20gently%20spreading%20radial%20glow%20with%20floating%20mail%20envelope%20icons%20and%20daily%20headline%20lines%2C%20deep%20warm%20cream%20and%20tomato%20red%20and%20amber%20tones%2C%20abstract%20minimal%20modern%20illustration&width=1600&height=520&seq=subscribe-band-gua&orientation=landscape"
        alt="吃瓜晚报订阅横幅背景"
        className="absolute inset-0 h-full w-full object-cover object-top opacity-60"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/80 via-background-900/60 to-background-950/80"></div>

      <div className="relative mx-auto flex max-w-[1200px] flex-col items-center px-4 text-center md:px-6">
        <h2 className="font-heading text-2xl font-black text-background-50 md:text-4xl">
          订阅吃瓜晚报，热点不再错过
        </h2>
        <p className="mt-4 max-w-xl text-sm leading-7 text-background-200 md:text-base">
          每天把值得追踪的中心瓜、关联人物与扩散进展整理成一份晚报送到你邮箱，
          忙里偷闲也能把瓜吃得明明白白。
        </p>

        <form
          id="newsletter-form"
          data-readdy-form
          onSubmit={handleSubmit}
          className="mt-8 flex w-full max-w-xl flex-col items-stretch gap-3 sm:flex-row"
        >
          <label className="hp-field" aria-hidden="true">
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              readOnly
            />
          </label>
          <input
            type="email"
            name="email"
            id="subscribe-email"
            required
            autoComplete="email"
            placeholder="输入你的邮箱地址"
            className="min-w-0 flex-1 rounded-md border border-background-200/60 bg-background-50/95 px-4 py-3 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-400/30"
          />
          <button
            type="submit"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400"
          >
            立即订阅
          </button>
        </form>

        <div className="mt-4 h-6 text-sm">
          {status === "success" && (
            <p className="inline-flex items-center gap-2 text-accent-200">
              <i className="ri-checkbox-circle-line"></i>
              {message}
            </p>
          )}
          {status === "error" && (
            <p className="inline-flex items-center gap-2 text-red-300">
              <i className="ri-error-warning-line"></i>
              {message}
            </p>
          )}
        </div>

        <p className="mt-1 text-xs text-background-400">
          订阅即代表同意我们仅用于发送晚报，你的邮箱不会被二次使用。
        </p>
      </div>
    </section>
  );
}